module.exports = __webpack_public_path__ + "img/2m.001f162e.png";